<template>
    <div v-if="!sentToken">
        <h4 class="mb-2">Forgot Password? 🔒</h4>
        <p class="mb-4">Enter your email and we'll send you instructions to reset your password</p>
        <form class="mb-3" @submit.prevent="handleForgotPassword">
            <div class="mb-3">
                <label for="email" class="form-label">Email</label>
                <input type="text" class="form-control" id="email"  placeholder="Enter your email" v-model="email"  required  autofocus />
            </div>
            <button class="btn btn-info d-grid w-100" type="submit">Send Reset Link</button>
            <div v-if="errorMessage" class="alert alert-danger mt-3" role="alert">
                Invalid email. Please try again.
            </div>
        </form>

    </div>

    <div v-else>
        <h4 class="mb-2">Email Sent</h4>
        <p class="mb-4">Instructions to reset your password was already sent to your email</p>
    </div>

    <div class="text-center">
        <a href="/login" class="d-flex align-items-center justify-content-center">
            <i class="bx bx-chevron-left scaleX-n1-rtl bx-sm"></i>
            Back to login
        </a>
    </div>
    
</template>

<script>
    import axios from 'axios';
    export default {
        data() {
        return {
            email: "",
            errorMessage: false,
            sentToken: false
        };
        },
        methods: {
            async handleForgotPassword() {
                try {
                    const response = await axios.post('/auth/forgot-password', {
                        email: this.email
                    }, { withCredentials: true }); // important for sessions
                    this.sentToken = true
                } catch (err) {
                    this.errorMessage = true;
                } 
            },
        },
    };
</script>

<style>
    
</style>
